export default "__VITE_ASSET__CiXO0M9v__"